import { lazy } from "react";

const LoginPage = lazy(() => import("../../pages/auth/login"));
const ResetPasswordPage = lazy(() => import("../../pages/auth/resetPassword"));

export const publicRoutes = [
  {
    name: "Login",
    path: "/login",
    component: LoginPage,
  },
  {
    name: "Reset Password",
    path: "/reset-password",
    component: ResetPasswordPage,
  },
];
